import { render, staticRenderFns } from "./DrvTable.vue?vue&type=template&id=7004c19e"
import script from "./DrvTable.vue?vue&type=script&lang=js"
export * from "./DrvTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports